import React from 'react';
import ShippingCartSummery from '../../common/shippingCartSummary/ShippingCartSummary';

const Payment = () => {
    return (
        <>
            <section class="checkout_cart_page_area">

                <div class="shipping_details_area">


                </div>
                <ShippingCartSummery button={false} />




            </section>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <h1>there will be a popular product section</h1>





        </>
    );
};

export default Payment;